import React, { useState } from 'react';
import { TabView, TabPanel } from "primereact/tabview";
import "./tabview.scss";

export function TabContent(props) {

    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <TabView className="w-100" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            {
                props.tabs.map((tab) =>
                    <TabPanel header={tab.header} leftIcon={tab.leftIcon}>
                        <div className={tab.sticky ? "py-3" : "p-3"}>
                            {tab.content}
                        </div>
                    </TabPanel>
                )
            }
        </TabView>
    );
}